import { createContext, useContext, useMemo } from 'react';

interface SidebarContextProps {
    isNewMobileView: boolean;
}

const SidebarIsNewMobileViewContext = createContext<SidebarContextProps>({
    isNewMobileView: false,
});

export function SidebarIsNewMobileViewStateProvider({
    value,
    children,
}: {
    value: boolean;
    children: React.ReactNode;
}) {
    const providerValue = useMemo(
        () => ({
            isNewMobileView: value,
        }),
        [value],
    );
    return (
        <SidebarIsNewMobileViewContext.Provider value={providerValue}>
            {children}
        </SidebarIsNewMobileViewContext.Provider>
    );
}

export function useSidebarIsNewMobileView() {
    return useContext(SidebarIsNewMobileViewContext).isNewMobileView;
}
